import * as React from "react";
import { Box, Typography, Avatar, Grid, Divider, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchAgencyDetail } from "../../DAL/fetch";
import LinearIndeterminate from "../../Components/LinearIndeterminate";
import { formatDate } from "../../Utils/Formatedate";
import { useTable } from "../../Components/useTable";
import ChangeStatusModel from "../../Components/Models/ChangeStatusModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
export default function AgencyDetail({ open, setOpen }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [openChangeStatusDialog, setOpenChangeStatusDialog] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [Modeltype, setModeltype] = useState("");
  const [Modeldata, setModelData] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetchAgencyDetail(id);

      if (response && response.data) {
        setData(response.data.data || response.data);
      }
    } catch (error) {
      console.error(`Failed to fetch user details:`, error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  const type = "AgencyUser";
  const headCells = [
    { id: "code", numeric: false, label: "Rid" },
    { id: "picture", numeric: false, label: "Picture" },
    { id: "name", numeric: false, label: "Name" },
    { id: "email", numeric: false, label: "Email" },
    { id: "phone", numeric: false, label: "Phone" },
    { id: "id", numeric: false, label: "UID" },
    { id: "firebaseUid", numeric: false, label: "Firebase Uid" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];
  const closeDialog = () => {
    fetchData();

    setOpenChangeStatusDialog(false);
  };
  const { tableUI } = useTable({
    headCells,
    type,
    dataFromparent: data?.users,
  });
  const openstatusdiolog = (status) => {
    setModeltype("Update");
    setModelData({ id, status });
    setOpenChangeStatusDialog(true);
  };

  return (
    <Box sx={{ padding: "3%" }}>
      {loading ? (
        <LinearIndeterminate />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              marginBottom: 2,
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <ArrowBackIcon
                sx={{ cursor: "pointer", mb: 1 }}
                onClick={() => navigate(-1)}
              />
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: "#8F29D0", alignSelf: "center" }}
              >
                <strong>Agency Detail</strong>
              </Typography>
            </Box>
            <Box>
              <Button
                sx={{
                  background: "linear-gradient(to right, #5301d7, #008eca)",
                  color: "white",
                  borderRadius: "6px",
                  marginRight: 3,
                  textTransform: "none",
                }}
                onClick={() => {
                  openstatusdiolog(data.status);
                }}
              >
                Change Status
              </Button>
              <Button
                sx={{
                  background: "linear-gradient(to right, #5301d7, #008eca)",
                  color: "white",
                  borderRadius: "6px",
                  textTransform: "none",
                }}
                onClick={() => {
                  navigate(`/agency/edit/${id}`);
                }}
              >
                Edit Details
              </Button>
            </Box>
          </Box>

          <Box sx={{ marginBottom: 4 }}>
            {/* Avatar */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              <Avatar
                alt={data.name}
                src={data.picture}
                sx={{ height: "100px", width: "100px" }}
              />
            </Box>

            {/* General Information */}
            <Typography
              variant="h6"
              gutterBottom
              sx={{ marginTop: 4, color: "#8F29D0" }}
            >
              <b>General Information</b>
              <Divider />
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Name:</strong> {data.name || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Email:</strong> {data.email || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Phone:</strong> {data.phone || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Rid:</strong> {data.rid || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Agency Code:</strong> {data.code || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Level:</strong> {data.level || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>ID:</strong> {data.id || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>UserName:</strong> {data.userName || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Password:</strong> {data.password || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Country:</strong> {data.country || "N/A"}
                </Typography>
              </Grid>
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ marginTop: 4, color: "#8F29D0" }}
            >
              <b>Accounts Detail</b>
              <Divider />
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Bank Name:</strong> {data.bankName || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Account Holder:</strong>{" "}
                  {data.bankAccountName || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Status:</strong> {data.status || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Address:</strong> {data.address || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Created At:</strong>{" "}
                  {formatDate(data.created) || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography>
                  <strong>Updated At:</strong>{" "}
                  {formatDate(data.updated) || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <div className="table-area">{tableUI}</div>
          <ChangeStatusModel
            open={openChangeStatusDialog}
            setOpen={closeDialog}
            Modeltype={Modeltype}
            Modeldata={Modeldata}
          />
        </>
      )}
    </Box>
  );
}
